import React from 'react';
import { Link } from 'react-router-dom';
import { BsClouds } from "react-icons/bs";
import { AiOutlineStock } from "react-icons/ai";
import "../introduction.css";

const Highlights = (props) => {
    const currentDate = new Date();

    const total_experience_duration = Math.ceil(parseFloat((currentDate - new Date(props.data.catch.started))/(24*60*60*1000*30*12)));
    const currentAge = parseInt((currentDate - new Date(props.about_me.dob))/(24*60*60*1000*30)/12);

    const highlights = props.data.highlights.map((highlight)=>{
        return(
            <div className='highlight_alt center flex_column' key={highlight.key} id={highlight.key}>
                <div className='me_digit'>
                    {highlight.digit}<span className='small'>{highlight.quantifier}</span>
                </div>
                <div className='highlight_sub'>
                        {highlight.details}
                </div>
            </div>
        )
    })

    highlights.push(
        [
            <div className='highlight_alt center flex_column' key="age" >
                <div className='me_digit'>
                    {total_experience_duration}<span className='small'>YEARS</span>
                </div>
                <div className='highlight_sub'>
                        of professional work experience creating innovative and impactful solutions.
                </div>
            </div>,
            <div className='highlight_alt center flex_column' key="age" >
                <div className='me_digit'>
                    {currentAge}<span className='small'>YEARS AGE</span>
                </div>
                <div className='me_digit'>
                    INDIAN
                </div>
            </div>
        ]
    )

    const currentPositions = props.data.jobs.map((job) => {
        return <div className='me_current_post_alt center flex_column'>           
                <div className='me_details_alt center flex_column'>
                    <span className='small' style={{padding: 10, textAlign: "center"}}><span style={{fontWeight:"900"}}>{job.title}</span> AT {job.company}, <span style={{fontWeight:"900",}}><br/>{job.organization}</span></span>
                </div>
                {/*<img className='logo' src={process.env.PUBLIC_URL + job.logo} />*/}
            </div>
        }
    )

    const currentEducation = props.data.education.map((ed) => {
        return <div className='education_alt center'>
            <div className='me_details_alt center flex_column' style={{textDecoration:"none", width: "100%"}}>
                <p><span style={{fontWeight:"900"}}>{ed.degree}</span><span className='small'> in </span> <span style={{fontWeight:"900"}}>{ed.major}</span></p>
                <span className='small'>Minors in {ed.minor.join(",")}</span>
                <div className='center'><span style={{fontWeight:"900", textAlign: "center"}}>{ed.institution}</span></div>
            </div>
            <div className='me_details_alt center'>
                <span style={{fontWeight:"900", textAlign: "center"}}>Expected {ed.graduation}</span>
                {/*<img className='ed_logo' src={process.env.PUBLIC_URL + ed.logo}/>*/}
            </div>
        </div>
    })

    const currentProjects = props.data.projects.map((prj) => {
        let icon = <BsClouds size={40} />;
        if (prj.type == "finance" ) {
            icon = <AiOutlineStock size={40}/>
        }
        return <div className='me_current_projects_alt me_details_alt center flex_column'>
            <div className='prj_icon'>{icon}</div>
            <p><span style={{fontWeight:"900"}}>{prj.name}</span></p>
            <p className='center'><span className='small prj_description'>{prj.description}</span></p>
        </div>
    })

    return(
        <div id='me'>
            <div className='container'>
                <div className='container_section center'>
                    <Link to="/experience" id='link_to_current_position' className='highlight_title_alt flex_column'>
                        CURRENT POSITIONS
                        <div className='small'>
                            View my experiences
                        </div>
                    </Link>
                    <div className='center' style={{width: "80%", alignSelf: "stretch"}}>
                        {[currentPositions]}
                    </div>
                </div>
                <div className='container_section center'>
                    <Link to="/" id='link_to_current_education' className='highlight_title_alt flex_column'>
                        CURRENT EDUCATION
                        <div className='small'>
                            Currently pursuing degree
                        </div>
                    </Link>
                    <div className='center' style={{width: "80%", alignSelf: "stretch"}}>
                        {[currentEducation]}
                    </div>
                </div>
                <div className='container_section center'>
                    <Link to="/projects" id='link_to_current_project' className='highlight_title_alt flex_column'>
                        CURRENT PROJECTS
                        <div className='small'>
                            View my projects
                        </div>
                    </Link>
                    <div className='center' style={{width: "80%", alignSelf: "stretch"}}>
                        {[currentProjects]}
                    </div>
                </div>
                <div className='highlight_title_alt' id='highlights_brick'></div>
                <div className='container_section center'>
                    {[highlights[0], highlights[1]]}
                </div>
                <div className='container_section center'>
                    {[highlights[2], highlights[3]]}
                </div>
                <div className='container_section center'>
                    {[highlights[4], highlights[5]]}
                </div>
            </div>
            <div className='poster_right'>
                <div className='poster'>
                    ONGOING WORK
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        The work that I am currently involved in and some of my achievements.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Highlights;